import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import useGet from '../../services/hooks/http/useGet';
import apiMethods from '../../apis';
import Context from '../../store/context';
import InfoBankSupplier from '../InfoBankSupplier/InfoBankSupplier';
import useFetch from '../../services/hooks/http/useFetch';

const AddAccountDruoSupplier = ({ supplierId, refetch }) => {
  const { businessId } = useSelector(state => state.userData);

  const {
    modal: { showError, hideModal },
    toast: { showSuccess }
  } = useContext(Context);

  const {
    isSuccess: updateSuccess,
    isError: updateError,
    sendRequest: updateSupplier,
    errorMessage: errorMessageUpdate
  } = useFetch(apiMethods.updateSupplier);

  const [supplierDataState, setsupplierDataState] = useState(null);

  const { isSuccess, data: supplierData, isError, errorMessage } = useGet(apiMethods.getSupplier, [businessId, supplierId]);

  useEffect(() => {
    if (isSuccess) {
      setsupplierDataState(supplierData);
    } else if (isError) {
      showError({ title: 'Información del proveedor', description: errorMessage });
    }
  }, [errorMessage, isError, isSuccess, showError, supplierData]);

  const onAccept = values => {
    const newSupplierBanksIds = values.supplierBanksIds.map(({ value }) => value);
    updateSupplier(businessId, supplierId, {
      ...(newSupplierBanksIds?.length > 0 && { newSupplierBanksIds }),
      ...(values.druoBankId && {
        newBankConnection: {
          druoBankId: values.druoBankId,
          druoBankAccountSubtype: values.druoBankAccountSubtype,
          bankAccountNumber: values.bankAccountNumber,
          typeOfPerson: values.paymentTypeOfPerson,
          identificationType: values.paymentIdentificationType,
          identificationNumber: values.paymentIdentificationNumber,
          businessName: values.paymentBusinessName,
          name: values.paymentName,
          lastName: values.paymentLastName,
          email: values.paymentEmail
        }
      })
    });
  };

  useEffect(() => {
    if (updateSuccess) {
      refetch && refetch();
      hideModal();
      showSuccess('Se actualizó la información del proveedor');
    } else if (updateError) {
      showError({ title: 'Actualizar proveedor', description: errorMessageUpdate });
    }
  }, [errorMessageUpdate, hideModal, refetch, showError, showSuccess, updateError, updateSuccess]);

  return (
    <div>
      {supplierDataState && (
        <InfoBankSupplier
          isEditSupplier={true}
          onAccept={onAccept}
          data={[]}
          infoSupplier={{
            paymentTypeOfPerson: supplierDataState.typeOfPerson,
            paymentName: supplierDataState.name,
            paymentLastName: supplierDataState.lastName,
            paymentBusinessName: supplierDataState.businessName,
            paymentIdentificationType: supplierDataState.identificationType,
            paymentIdentificationNumber: supplierDataState.identificationNumber,
            paymentEmail: supplierDataState.email
          }}
          infoValidateChange={{
            paymentTypeOfPerson: supplierDataState.typeOfPerson,
            paymentName: supplierDataState.name,
            paymentLastName: supplierDataState.lastName,
            paymentBusinessName: supplierDataState.businessName,
            paymentIdentificationType: supplierDataState.identificationType,
            paymentIdentificationNumber: supplierDataState.identificationNumber,
            paymentEmail: supplierDataState.email
          }}
        />
      )}
    </div>
  );
};

export default AddAccountDruoSupplier;
